<template>
    <div class="home">
        <div class="container">

            <h1 class="text-xs-center">Panel de control WPO WEBSITE</h1>
        </div>
    </div>
</template>

<script>

export default {
  name: 'home',
  created () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Home.vue?331266ba